// Codes exacts de la codification PROJECT_TYPE (table codification, seed
// tc_ecosys 0004_ide.sql). Seule source côté front : tout aiguillage sur le
// type de projet passe par resolveProjectType. Relevé UAT du 17/10/2026 :
// exactement ces 5 codes, 93 projets, aucune variante orthographique.
export const PROJECT_TYPE_CODE = {
  JAVASCRIPT_GAMING: 'JAVASCRIPT_GAMING',
  HTMLCSS_WEB: 'HTMLCSS_WEB',
  PYTHON_GAMING: 'PYTHON_GAMING',
  AI_BUILDER: 'AI_BUILDER',
  BLOCKLY_GAMING: 'BLOCKLY_GAMING',
} as const;

export type TProjectTypeCode = typeof PROJECT_TYPE_CODE[keyof typeof PROJECT_TYPE_CODE];

// « unknown » est un état à afficher, jamais un cas à remplacer par un type
// par défaut : un projet ouvert dans le mauvais éditeur se fait écraser à
// l'enregistrement.
export type TProjectTypeResolution =
  | { kind: 'known'; code: TProjectTypeCode }
  | { kind: 'unknown'; received: string };

const KNOWN_CODES: ReadonlySet<string> = new Set(Object.values(PROJECT_TYPE_CODE));

const isProjectTypeCode = (code: string): code is TProjectTypeCode => KNOWN_CODES.has(code);

// Égalité stricte : ni trim, ni casse, ni sous-chaîne. Un code qui ne figure
// pas dans la table doit se corriger dans les données, pas se deviner ici.
export const resolveProjectType = (code: string | undefined): TProjectTypeResolution =>
  code !== undefined && isProjectTypeCode(code)
    ? { kind: 'known', code }
    : { kind: 'unknown', received: code ?? '' };
